/* istanbul ignore file */
import { SidesheetComponentOptions, SidesheetSize } from '../enums';

// TODO: Width of every side sheet, applied to the shared drawer (see #13067), never inside a sheet's content.
//Update remaining Sidesheet when the standardization user story is completed to either small medium or large
export const SIDESHEET_SIZE_BY_COMPONENT: Record<SidesheetComponentOptions, SidesheetSize> = {
    [SidesheetComponentOptions.None]: SidesheetSize.Auto,
    [SidesheetComponentOptions.MapContextLayerForm]: SidesheetSize.Auto,
    [SidesheetComponentOptions.LogicBuilderForm]: SidesheetSize.Auto,
    [SidesheetComponentOptions.MapFieldPointForm]: SidesheetSize.Auto,
    [SidesheetComponentOptions.FeedbackForm]: SidesheetSize.Auto,
    [SidesheetComponentOptions.SiteActivityLogGrid]: SidesheetSize.Auto,
    [SidesheetComponentOptions.WidgetConfigurationForm]: SidesheetSize.Auto,
    [SidesheetComponentOptions.ReportDefinitionForm]: SidesheetSize.Auto,
    [SidesheetComponentOptions.UserAccountSettingsForm]: SidesheetSize.Small
};

export const NOTIFICATIONS_TAB_PATH = 'notifications';
